import React, { useState, useEffect } from 'react'
import api from '../services/api'
import CidadeSelect from '../components/CidadeSelect'

interface Codigo {
  id:                       number
  cid_cod:                  number
  cid_des:                  string
  cid_uf:                   string
  cod_tributacao_municipal: string
  aliquota_iss:             string | null
}

export default function CadastroTributacaoMunicipalNFSe() {
  const [lista, setLista]       = useState<Codigo[]>([])
  const [carregando, setCarregando] = useState(false)
  const [erro, setErro]         = useState('')

  const [cidCod, setCidCod]     = useState('')
  const [cidDes, setCidDes]     = useState('')
  const [cidIbge, setCidIbge]   = useState('')
  const [cidUf, setCidUf]       = useState('')
  const [codigo, setCodigo]     = useState('')
  const [aliquota, setAliquota] = useState('')
  const [salvando, setSalvando] = useState(false)

  async function carregar() {
    setCarregando(true)
    try {
      const r = await api.get('/nfse-servicos/municipios')
      setLista(r.data)
    } finally {
      setCarregando(false)
    }
  }

  useEffect(() => { carregar() }, [])

  function limparForm() {
    setCidCod(''); setCidDes(''); setCidIbge(''); setCidUf(''); setCodigo(''); setAliquota('')
    setErro('')
  }

  async function salvar() {
    if (!cidCod || (!codigo.trim() && !aliquota.trim())) {
      setErro('Informe a cidade e o código municipal ou a alíquota ISS.')
      return
    }
    setSalvando(true)
    setErro('')
    try {
      await api.post('/nfse-servicos/municipios', {
        cid_cod: Number(cidCod),
        cod_tributacao_municipal: codigo.trim(),
        aliquota_iss: aliquota.trim(),
      })
      limparForm()
      await carregar()
    } catch (e: any) {
      setErro(e.response?.data?.error ?? 'Erro ao salvar.')
    } finally {
      setSalvando(false)
    }
  }

  async function excluir(id: number) {
    if (!window.confirm('Excluir a tributação dessa cidade?')) return
    await api.delete(`/nfse-servicos/municipios/${id}`)
    await carregar()
  }

  return (
    <div style={{ maxWidth: 760 }}>
      <div className="card" style={{ marginBottom: '1.2rem' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.4rem' }}>Nova Tributação por Cidade</h3>
        <p style={{ fontSize: '0.82rem', color: '#6b7280', marginBottom: '1rem' }}>
          Código de Tributação Municipal e Alíquota ISS de cada cidade. Na emissão, ao escolher a cidade em
          "Local de Prestação", o sistema preenche os dois automaticamente. Salvar uma cidade já cadastrada
          substitui os valores dela.
        </p>

        <div className="form-grid" style={{ gridTemplateColumns: '1fr 160px 130px', gap: '0.75rem', alignItems: 'flex-end' }}>
          <div className="field">
            <label>Cidade *</label>
            <CidadeSelect
              codValue={cidCod} desValue={cidDes} ibgeValue={cidIbge} ufValue={cidUf}
              onChange={(cod, des, ibge, uf) => { setCidCod(cod); setCidDes(des); setCidIbge(ibge); setCidUf(uf) }}
            />
          </div>

          <div className="field">
            <label>Código Municipal</label>
            <input
              type="text" value={codigo}
              onChange={e => setCodigo(e.target.value.slice(0, 20))}
              placeholder="Ex: 0101"
            />
          </div>

          <div className="field">
            <label>Alíquota ISS (%)</label>
            <input
              type="text" value={aliquota} inputMode="decimal"
              onChange={e => setAliquota(e.target.value.replace(/[^0-9.,]/g, '').slice(0, 6))}
              placeholder="Ex: 5.00"
            />
          </div>
        </div>

        {erro && <div style={{ color: '#b91c1c', fontSize: '0.85rem', marginTop: '0.5rem' }}>{erro}</div>}

        <div style={{ display: 'flex', gap: 8, marginTop: '1rem' }}>
          <button className="btn btn-primary" onClick={salvar} disabled={salvando}>
            {salvando ? 'Salvando...' : 'Adicionar'}
          </button>
        </div>
      </div>

      <div className="card">
        <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '1rem' }}>
          Cidades cadastradas ({lista.length})
        </h3>

        {carregando && <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Carregando...</p>}
        {!carregando && lista.length === 0 && (
          <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Nenhuma cidade cadastrada.</p>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {lista.map(item => (
            <div
              key={item.id}
              style={{
                border: '1px solid #e5e7eb', borderRadius: 6, padding: '10px 14px',
                display: 'flex', alignItems: 'center', gap: 10,
              }}
            >
              <div style={{ flex: 1, minWidth: 0, fontWeight: 600, fontSize: '0.9rem' }}>
                {item.cid_des}{item.cid_uf ? `/${item.cid_uf}` : ''}
              </div>
              <div style={{ fontSize: '0.85rem', color: '#374151' }}>
                Código: <b>{item.cod_tributacao_municipal || '—'}</b>
              </div>
              <div style={{ fontSize: '0.85rem', color: '#374151' }}>
                ISS: <b>{item.aliquota_iss != null ? `${Number(item.aliquota_iss).toFixed(2)}%` : '—'}</b>
              </div>
              <button
                className="btn btn-outline btn-sm"
                style={{ color: '#b91c1c' }}
                onClick={() => excluir(item.id)}
              >
                Excluir
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
